import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { HttpClientModule } from "@angular/common/http";

import { DataTableModule, SharedModule, MessagesModule, PaginatorModule,
    GrowlModule, ConfirmDialogModule, ConfirmationService, DialogModule, MultiSelectModule,
    MenuModule, ButtonModule, DropdownModule, ContextMenuModule, CheckboxModule
} from "primeng/primeng";
import { AppNavigationService, AuthorizationHelperService, AuthorizationService, BrandingService, ConcludeSSOLoginComponent,
    DropdownComponentModule, EnvironmentComponentModule, GlobalService, LocalStorageService, MessagesService, SessionStorageService,
    RequestSSOLoginComponent, SpinnerComponentModule, UnauthorizedAccessComponent, UserService
} from "@nordpoolgroup/nps-angular-2-common";

import { ApplicationBarLayoutModule } from "./ApplicationBar/ApplicationBarLayoutModule";
import { AppRoutingModule } from "./AppRoutingModule";
import { AppComponent } from "./AppComponent";

import { MainViewComponent } from "./MainView/MainViewComponent";
import { PullOutMenuLayoutComponent } from "./PullOutMenu/PullOutMenuLayoutComponent";
import { ContractManagementComponent } from "./ContractManagement/ContractManagementComponent";
import { ContractStatusPipe } from "./ContractManagement/ContractStatusPipe";
import { DeliveryTimePipe } from "./ContractManagement/DeliveryTimePipe";


@NgModule({
    declarations: [
        AppComponent,
        RequestSSOLoginComponent,
        ConcludeSSOLoginComponent,
        UnauthorizedAccessComponent,
        MainViewComponent,
        ContractManagementComponent,
        PullOutMenuLayoutComponent,
        ContractStatusPipe,
        DeliveryTimePipe
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        HttpModule,
        HttpClientModule,
        AppRoutingModule,
        ApplicationBarLayoutModule,
        MessagesModule,
        GrowlModule,
        DataTableModule,
        PaginatorModule,
        SpinnerComponentModule,
        MenuModule,
        ButtonModule,
        DropdownModule,
        MultiSelectModule,
        ContextMenuModule,
        CheckboxModule,
        EnvironmentComponentModule,
        ConfirmDialogModule,
    ],
    providers: [
        GlobalService,
        AppNavigationService,
        BrandingService,
        AuthorizationService,
        SessionStorageService,
        UserService,
        LocalStorageService,
        MessagesService,
        AuthorizationHelperService,
        ConfirmationService,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/AppModule.ts